// Runtime auth config (EW-166): deployed environments serve /config.json
// (generated by the nginx entrypoint from container env vars) so one neutral
// image works everywhere. Local dev has no /config.json — callers fall back
// to the Vite-baked VITE_* values.
//
// EW-66: the authority is runtime too. `authorityUrl` set = a generic OIDC
// issuer (e.g. a customer Keycloak realm); empty = the Entra authority is
// derived from `entraTenantId`.
// EW-291: the customer branding; the colours come from /branding/branding.css.
export interface RuntimeBranding {
  appName: string | null;
  logoUrl: string | null;
  hasDarkPalette: boolean;
}

export interface RuntimeConfig {
  entraTenantId?: string;
  adminClientId?: string;
  authorityUrl?: string;
  apiBaseUrl?: string;
  echoProxyBaseUrl?: string;
  /** Product version stamped into the image at build time; absent in local dev. */
  buildVersion?: string;
  /** Git SHA of the source the image was built from. */
  buildCommit?: string;
  // EW-255: null is a value here, not an omission — see auth/features.ts.
  enabledFeatures?: string | null;
  branding?: RuntimeBranding | null;
}

export async function fetchRuntimeConfig(): Promise<RuntimeConfig | null> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (!res.ok) return null;
    return (await res.json()) as RuntimeConfig;
  } catch {
    return null;
  }
}
